var _classCallCheck = require("C:\\Users\\Simeon\\Desktop\\notifications-component\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\Simeon\\Desktop\\notifications-component\\node_modules\\@babel\\runtime/helpers/createClass");

/**
 * Replaces native WebSocket with a fake behaviour.
 * Uses runloop api to emit fake messages, also
 * serializes and deserializes messages.
 */
var R = require('./runloop');

var nativeSocket = window.WebSocket;
var runloop;

var FakeSocket =
/*#__PURE__*/
function () {
  "use strict";

  function FakeSocket() {
    _classCallCheck(this, FakeSocket);

    this._runloop = runloop;

    this._runloop.on('message', this._onRunloopEvent(this));
  }

  _createClass(FakeSocket, [{
    key: "_onRunloopEvent",
    value: function _onRunloopEvent(socket) {
      return function (message) {
        if (!socket.onmessage) return;
        var messageText = JSON.stringify(message); //TODO: Replicate Event interface
        //TODO: Check if we have to bind the method with the socket context

        socket.onmessage({
          data: messageText
        });
      };
    }
  }], [{
    key: "CLOSED",
    get: function get() {
      return nativeSocket.CLOSED;
    }
  }, {
    key: "CLOSING",
    get: function get() {
      return nativeSocket.CLOSING;
    }
  }, {
    key: "CONNECTING",
    get: function get() {
      return nativeSocket.CONNECTING;
    }
  }, {
    key: "OPEN",
    get: function get() {
      return nativeSocket.OPEN;
    }
  }]);

  return FakeSocket;
}();

var listen = function listen(definitions, options) {
  runloop = R(definitions, options);
  window.WebSocket = FakeSocket;
  runloop.poll();
};

var close = function close() {
  window.WebSocket = nativeSocket;
  runloop.stop();
};

module.exports = {
  listen: listen,
  close: close,
  FakeSocket: FakeSocket
};